import { Box, Typography } from "@mui/material"
import { useStyles } from "./styles"

export const KeyCaption = ({ number, text }: { number: number | string; text: string }) => {
    const styles = useStyles()
    return (
        <Box sx={styles.display}>
            <Typography sx={styles.number}>{number}</Typography>
            <Typography sx={styles.text}>{text}</Typography>
        </Box>
    )
}